module.exports = __webpack_public_path__ + "img/DJ.233bb83a.svg";